import React from 'react'
import { connect } from 'react-redux'
// import SvgIconAmenities from './SvgIconAmenities'
import Loadable from 'Components/LoadableToImported'

const SvgIconAmenities = Loadable({
  loader: () => import(/* webpackChunkName: "SvgIconAmenities" */'./SvgIconAmenities'),
  loading: () => <div />,
  chunkName: 'SvgIconAmenities',
})

export default connect(state => ({
  mobileBrowser: state.app.mobileBrowser,
}))(SvgIconAmenities)


const LoadableSvgIconAmenities = Loadable({
  loader: () => import(/* webpackChunkName: "SvgIconAmenities" */ './SvgIconAmenities'),
  loading: () => <div />,
  chunkName: 'LoadableSvgIconAmenities',
})

export const PreLoadedSvgIconAmenities = connect(state => ({
  mobileBrowser: state.app.mobileBrowser,
}))(LoadableSvgIconAmenities)
